import React, {useState} from "react";
import PropTypes from "prop-types";
import SelectCreator from "./SelectCreator";

const SortCreator = ({options, onSort}) => {
  const [selectedValue, setSelectedValue] = useState(undefined);

  const sortOptions = options.flatMap((option) => [
    {label: `${option.label} (Asc)`, value: `${option.value}-asc`},
    {label: `${option.label} (Desc)`, value: `${option.value}-desc`},
  ]);

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
    onSort(e.target.value);
  };

  return (
    <SelectCreator
      isClearable
      label="Sort By"
      onChange={handleChange}
      options={sortOptions}
      value={selectedValue}
    />
  );
};

SortCreator.propTypes = {
  /** The name o fields on whose basis rows are to sorted */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  /** The function to be called when sorting is done */
  onSort: PropTypes.func.isRequired,
};

export default SortCreator;
